import { useVisuallyHidden } from 'react-aria'

interface DndAnnouncerProps {
	message: string
}

export function DndAnnouncer({ message }: DndAnnouncerProps) {
	const { visuallyHiddenProps } = useVisuallyHidden()

	return (
		<output {...visuallyHiddenProps} aria-live='polite'>
			{message}
		</output>
	)
}
